<ig-inline-alert severity="warning">Oops... you found our secret debug panel! But don't be scared - you can't do anything evil here...</ig-inline-alert>
<br>
<div class="p-grid">
  <div class="p-col-6">
    <h5 class="headline">Panel Info</h5>
  <span class="ig-typo-panel-strong--medium labelsize1">Version: </span> <ig-copy-clipboard>{{ panelVersion }}</ig-copy-clipboard
  ><br />
  <span class="ig-typo-panel-strong--medium labelsize1">VersionHash: </span> <ig-copy-clipboard>{{ panelVersionHash }}</ig-copy-clipboard>
  <br />
  <span class="ig-typo-panel-strong--medium labelsize1">Angular: </span> <ig-copy-clipboard>{{ angularVersion }}</ig-copy-clipboard>
  <br />
  <span class="ig-typo-panel-strong--medium labelsize1">datacenter: </span> <ig-copy-clipboard>{{ datacenter }}</ig-copy-clipboard>
  </div>
  <div class="p-col-6">
    <h5 class="headline">User Info</h5>
  <span class="ig-typo-panel-strong--medium labelsize1">UserRole: </span> {{ userRole$ | async }} <br>

  </div>
</div>

  <br>
  <p-accordion>
    <p-accordionTab header="Active Partner Features">
      <ul class="flist">
        <li *ngFor="let feature of activeFeatureFlags$ | async">
          {{ feature }}

        </li>
      </ul>
    </p-accordionTab>

    <p-accordionTab header="User Store data">
      <pre>
        {{ userStoreData$ | async | json }}
      </pre>
    </p-accordionTab>

</p-accordion>

  <br>
<div >
  <h5 class="headline">User Store</h5>
  <div class="button-grid">

    <ig-button mode="danger" (onClick)="resetUserStore()" label="Reset Complete User Store"></ig-button>
  </div>
</div>
